var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconCommunicationsDefault = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#4A606A",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m19.374 15.342 8.532 5.4V9.726zM2.598 9.726v11.016l8.532-5.4zM26.322 6.522H4.182c-.792 0-1.422.594-1.53 1.35l12.6 8.298 12.6-8.298c-.126-.756-.738-1.35-1.53-1.35zM17.916 16.296l-2.232 1.476a.755.755 0 0 1-.432.126.755.755 0 0 1-.432-.126l-2.232-1.476-9.918 6.282c.126.756.738 1.332 1.53 1.332h22.14c.792 0 1.404-.576 1.53-1.332l-9.954-6.282z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconCommunicationsDefault);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-communications-default.038f43e5f70b1cbb228e4e4aa61f203d.svg";